<template lang="pug">
v-app-bar.px-5(fixed)
  .d-flex.mx-auto(style="max-width: 1600px; width: 100%")
    img(src="@/assets/images/logo.png", height="40")
    v-spacer
    .d-flex.align-items-center.nav-items(v-if="$vuetify.breakpoint.mdAndUp")
      v-btn(@click="goTo('/')", text, :class="{ active: isActive('default') }") Home
      v-btn(
        @click="goTo('/services')",
        text,
        :class="{ active: isActive('services') }"
      ) Our Services
      //- v-btn(
      //-   @click="goTo('/about')",
      //-   text,
      //-   :class="{ active: isActive('about') }"
      //- ) About us
      v-btn(
        @click="goTo('/clients')",
        text,
        :class="{ active: isActive('clients') }"
      ) Clients
      v-btn(
        @click="goTo('/contact')",
        text,
        :class="{ active: isActive('contact') }"
      ) Contact us

    div(v-if="$vuetify.breakpoint.smAndDown")
      v-menu(bottom)
        template(v-slot:activator="{ on, attrs }")
          v-btn(v-bind="attrs", v-on="on", text)
            .d-block
              v-icon(style="color: #009cb1", size="xlarge") mdi-menu
              p(style="font-size: 7px; color: #1f9599; margin: 0") Menu

        v-list
          v-list-item(
            @click="goTo('/')",
            text,
            :class="{ active: isActive('default') }"
          )
            v-list-item-title.text-blue Home
          v-list-item(
            @click="goTo('/services')",
            text,
            :class="{ active: isActive('services') }"
          )
            v-list-item-title.text-blue Our Services
          v-list-item(
            @click="goTo('/about')",
            text,
            :class="{ active: isActive('about') }"
          )
            v-list-item-title.text-blue About us
          v-list-item(
            @click="goTo('/clients')",
            text,
            :class="{ active: isActive('clients') }"
          )
            v-list-item-title.text-blue Clients
          v-list-item(
            @click="goTo('/contact')",
            text,
            :class="{ active: isActive('contact') }"
          )
            v-list-item-title.text-blue Contact us
</template>

<script>
export default {
  name: "XOToolbar",
  data() {
    return {
      page: window.location.href,
    };
  },
  methods: {
    goTo(page) {
      window.location.href = page;
    },
    isActive(page) {
      if (!this.activeRoute && page === "default") return true;
      return page === this.activeRoute;
    },
  },
  computed: {
    activeRoute() {
      const data = this.page.split("/") || [];
      return data[data.length - 1];
    },
  },
};
</script>

<style lang="sass">
.nav-items
  .v-btn__content
    text-transform: none !important
</style>
